var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.954,
    height: 18.824,
    viewBox: "0 0 17.954 18.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3552.781,270.921a1.9,1.9,0,0,1-1.4-.613l-13.772-15.036a1.9,1.9,0,0,1,2.8-2.561l13.77,15.038a1.894,1.894,0,0,1-1.4,3.171Z",
    transform: "translate(-3537.114 -252.097)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3539.258,270.391a1.895,1.895,0,0,1-1.389-3.185l13.491-14.476a1.9,1.9,0,0,1,2.773,2.584l-13.491,14.474A1.886,1.886,0,0,1,3539.258,270.391Z",
    transform: "translate(-3536.66 -251.987)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrar);
export default __webpack_public_path__ + "static/media/cerrar.9051ec95c731e22d85a591437685aa7b.svg";
export { ForwardRef as ReactComponent };